import React from "react";

const sharedStyle = "p-1 rounded-full text-xs ";
const styles = {
  primary: `${sharedStyle} bg-purple-500 text-white`,
  admin: `${sharedStyle} bg-red-500 text-white`,
  user: `${sharedStyle} bg-green-500 text-white`,
  employee: `${sharedStyle} bg-blue-500 text-white`,
};

const Tag = ({ text, type, className }) => {
  return <span className={styles[type] + ` ${className}`}>{text}</span>;
};

export default Tag;
